import cookies from './cookies';
export default function Client(options) {
    const { overrides, optimizelyClient, getUserId, getUserAttributes, onFeatureRequest, onExperimentRequest } = options;
    const getFeatureFlag = (featureKey) => {
        const userId = getUserId();
        const userAttributes = getUserAttributes();
        if (overrides === null || overrides === void 0 ? void 0 : overrides.includes(featureKey)) {
            return { isEnabled: true };
        }
        const isEnabled = optimizelyClient.isFeatureEnabled(featureKey, userId, userAttributes);
        const variables = optimizelyClient.getAllFeatureVariables(featureKey, userId, userAttributes);
        if (onFeatureRequest) {
            onFeatureRequest({ featureKey, userId, variables, isEnabled });
        }
        return { isEnabled, variables };
    };
    const updateFeatureCookie = (featureKey, isEnabled) => {
        const features = cookies.getFeatures();
        if (isEnabled) {
            if (!features.includes(featureKey)) {
                cookies.setFeatures([...features, featureKey]);
            }
        }
        else {
            cookies.setFeatures(features.filter(item => item !== featureKey));
        }
    };
    const activateExperiment = (experimentKey, userId = getUserId()) => {
        const variant = optimizelyClient.activate(experimentKey, userId, getUserAttributes());
        if (onExperimentRequest) {
            onExperimentRequest({ experimentKey, userId, variant });
        }
        return variant;
    };
    const trackEvent = (eventName) => {
        const user = optimizelyClient.createUserContext(getUserId(), getUserAttributes());
        if (user) {
            user.trackEvent(eventName);
        }
    };
    const isReady = async () => {
        try {
            const { success } = await optimizelyClient.onReady();
            return success;
        }
        catch (error) {
            console.warn('Error while waiting for optimizelyClient');
            return false;
        }
    };
    return {
        getFeatureFlag,
        updateFeatureCookie,
        activateExperiment,
        trackEvent,
        isReady,
    };
}
